import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=7f4cb783&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=7f4cb783&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f4cb783')) {
      api.createRecord('7f4cb783', component.options)
    } else {
      api.reload('7f4cb783', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=7f4cb783&", function () {
      api.rerender('7f4cb783', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/internalAudit/components/details/detail.vue"
export default component.exports